onComplete(function () {
	const buttons = document.querySelectorAll('a[href="https://www.pearle.nl/maak-afspraak/what?storeId=N492"]');

	console.log(buttons);

	// Loop door de resultaten en voeg de class toe
	buttons.forEach(button => {
		button.classList.add('conversion');
	});
});